import React from 'react'

export const IndexContext = React.createContext({page: 1})